module.exports = __webpack_public_path__ + "img/54.385e9eae.jpeg";